(function(){
  // scroll reveals
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.15});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  // product gallery
  var mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(!mainImg) return;
      mainImg.src = btn.dataset.src;
      document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('on'); });
      btn.classList.add('on');
    });
  });

  // variant price update
  var vSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  var addBtn = document.querySelector('[data-add-btn]');
  if(vSelect){
    var variants = [];
    try { variants = JSON.parse(document.getElementById('VariantsJson').textContent); } catch(e){}
    vSelect.addEventListener('change', function(){
      var v = variants.find(function(x){ return String(x.id) === vSelect.value; });
      if(!v) return;
      if(priceEl && v.price_formatted) priceEl.innerHTML = v.price_formatted;
      if(addBtn){
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    });
  }

  // size guide unit toggle
  var uCm = document.getElementById('uCm'), uIn = document.getElementById('uIn');
  function setUnit(u){
    if(uCm) uCm.classList.toggle('on', u==='cm');
    if(uIn) uIn.classList.toggle('on', u==='in');
    document.querySelectorAll('[data-cm]').forEach(function(td){
      td.textContent = (u==='cm') ? td.dataset.cm + ' cm' : td.dataset.in + '"';
    });
  }
  if(uCm && uIn){
    uCm.addEventListener('click', function(){ setUnit('cm'); });
    uIn.addEventListener('click', function(){ setUnit('in'); });
    setUnit('cm');
  }
})();
